import * as React from 'react';

export function ErrorFallback(): React.JSX.Element {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-background">
      <div className="text-center">
        <p className="mb-2 text-sm text-muted-foreground">Something went wrong.</p>
        <button
          type="button"
          className="text-sm text-primary underline"
          onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    </div>
  );
}
